<template>
  <div :style="outStyle">
    <el-select
      :disabled="disabled"
      :value="value"
      :size="size"
      :clearable="clearable"
      :placeholder="placeholder"
      :collapse-tags="collapse"
      :multiple="multiple"
      @change="changeOperator"
      :style="'width:' + inputWidth"
    >
      <el-option
        v-if="defaultOption"
        :disabled="true"
        :label="placeholder"
        value=""
        >{{ placeholder }}</el-option
      >
      <el-option
        v-for="v in optionArr"
        :key="v[valueField]"
        :label="v[labelField]"
        :value="v[valueField]"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  name: "KeySelect",
  props: {
    value: [String, Array],
    optionArr: Array,
    placeholder: String,
    outStyle: {
      type: Object,
      default: () => ({
        display: "inline-block",
        marginRight: "6px"
      })
    },
    inputWidth: {
      type: String,
      default: "140px"
    },
    size: {
      type: String,
      default: "medium"
    },
    multiple: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    defaultOption: {
      type: Boolean,
      default: false
    },
    collapse: {
      type: Boolean,
      default: false
    },
    valueField: {
      type: String,
      default: "code"
    },
    labelField: {
      type: String,
      default: "name"
    }
  },
  methods: {
    changeOperator(val) {
      this.$emit("input", val);
      this.$emit("changeSelect", val);
    }
  }
};
</script>
